import React from 'react';

function Loading() {
    return (
        <div className="section section-center">
            <div className="loading" />
        </div>
    );
}

export default Loading;
